import React, { useContext } from 'react';
import Critica from './Critica';
import proyectoContext from '../../context/proyectos/proyectoContext';
import criticaContext from '../../context/criticas/criticaContext';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FaHandPointLeft, } from "react-icons/fa";
import Swal from 'sweetalert2';

const ListadoCriticas = () => {

    // Extrar proyectos de state inicial
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, eliminarProyecto } = proyectosContext;

    // obtener las criticas del proyecto
    const criticasContext = useContext(criticaContext);
    const { criticasproyecto } = criticasContext;

    // Si no hay proyecto seleccionado
    if (!proyecto) return <h2><FaHandPointLeft />  Selecciona una Carpeta</h2>;

    // Array destructuring para extraer el proyecto actual
    const [proyectoActual] = proyecto;

    // Elimina un proyecto
    const onClickEliminar = () => {

        Swal.fire({
            title: '¿Estás seguro que quieres borrar la Carpeta?',
            text: "Luego no podras recuperarla...",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3c1053',
            cancelButtonColor: '#2f3848',
            confirmButtonText: 'Si, borrar.'
        }).then((result) => {
            if (result.isConfirmed) {
                eliminarProyecto(proyectoActual._id)
                Swal.fire(
                    'Carpeta Borrada!',
                    'Se ha borrado con éxito.',
                    'success'
                )
            }
        })
    }

    return (
        <div>
            <h2>Carpeta: {proyectoActual.nombre} </h2>

            <ul className="listado-tareas">
                {criticasproyecto.length === 0
                    ? (<li className="tarea"><p>No hay Criticas</p></li>)
                    :
                    <div className="ordenarCriticas">
                        <TransitionGroup>
                            {criticasproyecto.map(critica => (
                                <CSSTransition
                                    key={critica.id}
                                    timeout={200}
                                    classNames="tarea"
                                >
                                    <Critica
                                        critica={critica}
                                    />
                                </CSSTransition>
                            ))}
                        </TransitionGroup>
                    </div>
                }
            </ul>

            <button
                type="button"
                className="btn btn-eliminar"
                onClick={onClickEliminar}
            >Eliminar Carpeta &times;</button>
        </div>
    );
}

export default ListadoCriticas;